import Stack, { StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import VenetianMaskIcon from '@liquidweb-dev/undercurrent/icons/lucide/VenetianMask';

import { useAuth } from 'react-oidc-context';

const MasqueradeNote = ({ sx, ...rest }: StackProps) => {
	const { user } = useAuth();

	if (!user?.profile?.masquerade) {
		return null;
	}

	return (
		<Stack
			direction="row"
			spacing={100}
			{...rest}
			sx={combineSx(
				{
					borderTopLeftRadius: ({ borderRadius }) => borderRadius.roundedSm,
					borderTopRightRadius: ({ borderRadius }) => borderRadius.roundedSm,
					backgroundColor: ({ vars }) => vars.palette.uc.highlight.bg.main,
					paddingX: 200,
					paddingTop: 100,
					paddingBottom: 100,
					justifyContent: 'center',
					alignItems: 'center',
				},
				sx,
			)}
		>
			<VenetianMaskIcon
				sx={({ size, vars }) => ({
					color: vars.palette.uc.highlight.icon.main,
					width: size.sm,
					height: size.sm,
				})}
			/>
			<Typography variant="body-sm">Masquerade mode active</Typography>
		</Stack>
	);
};

export default MasqueradeNote;
